import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

interface DataImportErrorResult {
  errors: any[];
}

@Component({
  selector: 'app-data-import-error-modal',
  templateUrl: './data-import-error-modal.component.html',
  styleUrls: ['./data-import-error-modal.component.scss'],
})
export class DataImportErrorModalComponent {
  constructor(
    public dialogRef: MatDialogRef<DataImportErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataImportErrorResult
  ) {}

  format(str: string) {
    if (!str?.endsWith('.')) {
      return str + '.';
    }
    return str;
  }
}
